(function (root) {
  function createCartOperations() {
    let tail = Promise.resolve();
    let pending = 0;
    let failures = 0;
    let blocked = false;
    let generation = 0;
    const notify = () => {
      if (typeof document !== 'undefined') document.dispatchEvent(new CustomEvent('cart:operations-changed'));
    };
    function error(code, message, extra = {}) {
      return Object.assign(new Error(message || 'Warenkorb konnte nicht sicher aktualisiert werden.'), { code, ...extra });
    }
    const api = {
      hasPending: () => pending > 0,
      pendingCount: () => pending,
      failureCount: () => failures,
      isBlocked: () => blocked,
      markUncertain() { blocked = true; notify(); },
      run(callback, { mutation = true, purchase = true } = {}) {
        if (purchase) pending += 1;
        notify();
        const execute = async () => {
          if (mutation && blocked) throw error('blocked');
          const id = ++generation;
          let active = true;
          let uncertain = false;
          const operation = {
            isCurrent: () => active && id === generation,
            isUncertain: () => uncertain,
            markUncertain() {
              uncertain = true;
              if (purchase) api.markUncertain();
            },
            async requestJSON(url, options = {}, { timeoutMs = 10000 } = {}) {
              const controller = new AbortController();
              const writes = mutation && !['GET', 'HEAD'].includes((options.method || 'GET').toUpperCase());
              let timer;
              let expired = false;
              const deadline = new Promise((_, reject) => {
                timer = setTimeout(() => {
                  expired = true;
                  controller.abort();
                  reject(error('timeout'));
                }, timeoutMs);
              });
              try {
                return await Promise.race([deadline, (async () => {
                  const response = await fetch(url, { ...options, signal: controller.signal });
                  let data;
                  try {
                    if (typeof response.text === 'function') {
                      const text = await response.text();
                      data = text ? JSON.parse(text) : null;
                    } else data = await response.json();
                  } catch (cause) { throw error('parse', undefined, { cause }); }
                  if (expired || !operation.isCurrent()) throw error('stale');
                  if (!response.ok) {
                    if (writes && (response.status >= 500 || response.status === 408)) operation.markUncertain();
                    throw error('http', data?.description || data?.message, { status: response.status, data });
                  }
                  return data;
                })()]);
              } catch (cause) {
                if (writes && !['http', 'blocked'].includes(cause.code)) operation.markUncertain();
                throw cause.code ? cause : error('network', undefined, { cause });
              } finally { clearTimeout(timer); }
            },
          };
          try { return await callback(operation); }
          finally { active = false; }
        };
        const queued = tail.then(execute, execute);
        const settled = queued.then(
          (result) => { if (purchase && result === false) failures += 1; return result; },
          (cause) => { if (purchase) failures += 1; throw cause; },
        ).finally(() => { if (purchase) pending -= 1; notify(); });
        tail = settled.catch(() => {});
        return settled;
      },
      async waitForIdle() {
        const initialFailures = failures;
        while (pending > 0) { const observed = tail; await observed; if (observed !== tail) continue; }
        return !blocked && failures === initialFailures;
      },
    };
    return api;
  }
  root.createCartOperations = root.createCartOperations || createCartOperations;
  root.CartOperations = root.CartOperations || createCartOperations();
})(globalThis);
